<div mat-dialog-title class="change-site-state">
  {{ data.title ? data.title : 'Option Select' }}
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <p class="line-1">
    {{ data.line1 ? data.line1 : "Please select an option:" }}
  </p>
  <form [formGroup]="selectForm" class="select-form">
    <mat-form-field class="layer-select">
      <mat-select formControlName="field" placeholder="Select a layer">
        @for (option of options; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button
    data-cy="button-yes"
    mat-raised-button
    color="primary"
    class="green-shadow-button"
    (click)="onYesClick()">
    {{ data.buttonText ? data.buttonText : 'Option Select' }}
  </button>
</div>
